<template>
  <div class="wrapper">
    <div class="btn-toolbar justify-content-between" role="toolbar">
      <button @click="save" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button><br/><br/>
      <button @click="deleteUser" class="btn btn-danger"><font-awesome-icon icon="trash"/>&nbsp;L&ouml;schen</button>
    </div>
    <div class="row">
      <div class="col-md">
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Vorname:</label>
              <input class="form-control" type="text" v-model="user.firstname"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Nachname:</label>
              <input class="form-control" type="text" v-model="user.lastname"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>E-Mail:</label>
              <input type="text" class="form-control" v-model="user.email"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Kennung:</label>
              <input type="text" v-model="user.userKey" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>IM-Kontakt:</label>
              <input type="text" v-model="user.imcontact" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Telegram:</label>
              <input type="text" v-model="user.telegram" class="form-control">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="row">
          <div class="col-sm">
            <label>Zusatzfelder</label>
            <div class="wrapper">
              <ul class="list-group">
                <li class="list-group-item">
                  <div class="row">
                    <div class="col-md">
                      <input class="form-control" placeholder="Name" v-model="extrakey" type="text"/>
                    </div>
                    <div class="col-xs"><strong>=</strong></div>
                    <div class="col-md">
                      <input class="form-control" type="text" v-model="extraval" placeholder="Wert"/>
                    </div>
                    <div class="col-xs">
                      <button @click="addExtraField" class="btn btn-primary" name="rempattern"><font-awesome-icon icon="plus"/></button>
                    </div>
                  </div>
                </li>
                <li class="list-group-item" v-for="(val,key) in user.extend" :key="key">
                  <div class="row">
                    <div class="col-md">
                      <input disabled class="form-control" placeholder="Name" :value="key" type="text"/>
                    </div>
                    <div class="col-xs"><strong>=</strong></div>
                    <div class="col-md">
                      <input class="form-control" type="text" v-model="user.extend[key]" placeholder="Wert"/>
                    </div>
                    <div class="col-xs">
                      <button @click="remExtraField(key)" class="btn btn-danger" name="rempattern"><font-awesome-icon icon="trash"/></button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr/>
        <h5>Rollen</h5>
        <div class="row">
          <div class="col-sm">
            <b class="mr-3">Aktive</b>
            <button @click="remRoles" class="btn btn-secondary"><font-awesome-icon icon="minus"/></button>
            <select v-model="selectactive" class="form-control" size="10" multiple="true" id="active">
                <option v-for="item in userroles" :key="item" :value="item">{{ item }}</option>
            </select>
          </div>
          <div class="col-sm">
            <b class="mr-3">Alle</b>
            <button @click="addRoles" class="btn btn-secondary"><font-awesome-icon icon="plus"/></button>
            <select v-model="selectall" size="10" id="allroles" class="form-control" multiple="true">
                <option v-for="item in allroles" :key="item.roleId" :value="item">{{ item.roleId }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import sysuser from '@/modules/sysuser.js'

export default {
  name: 'UserEntry',
  props: ["user"],
  data() {
    return {
      allroles: [],
      selectall: [],
      selectactive: [],
      extrakey: '',
      extraval: '',
      userroles: []
    }
  },
  watch: {
    user: function() {
      console.log(this.user);
      if (this.user && this.user.id) {
        this.fetchRoles();
      }
    }
  },
  created() {
    var self = this;
    sysuser.availableRoles().then(function(data) {
      self.allroles = data;
    });
  },
  methods: {
    addExtraField() {
      console.log('add ef: ' + this.extrakey);
      if (this.extrakey === '') {
        this.$bvToast.toast('Bitte erst einen kurzen Namen für das Extrafeld eingeben.',{title:'Benutzer',variant:'warning'})
        return;
      }
      // vue and bad data design workaround :(
      var temp = JSON.parse(JSON.stringify(this.user.extend || {}));
      temp[this.extrakey] = this.extraval;
      this.user.extend = temp;
      this.extrakey = '';
      this.extraval = '';
      console.log(JSON.stringify(this.user.extend));
    },
    remExtraField(key) {
      console.log('rem extra: ' + key);
      // vue and bad data design workaround :(
      var temp = JSON.parse(JSON.stringify(this.user.extend || {}));
      delete temp[key];
      this.user.extend = temp;
      console.log(temp);
    },
    saveRoles: function() {
      var self = this;
      sysuser.saveroles(this,this.user.id,this.userroles,function() {
        self.$bvToast.toast('Rollen gespeichert.',{ title: 'Rollen', variant: 'success'});
      });
    },
    save: function() {
      var self = this;
      sysuser.save(this,this.user,function(data) {
        console.log(data);
        if (data.id) {
          self.user = data; // update for id if new user
        }
        self.$bvToast.toast('Benutzer gespeichert',{ title: 'Benutzer', variant: 'success' })
        self.saveRoles();
        self.$emit('update',data);
      })
    },
    deleteUser: function() {
      if (!this.user || this.user.id == 0) {
        return;
      }

      if (confirm('Möchten Sie wirklich den Benutzer "'+ this.user.firstname + ' ' + this.user.lastname + '" löschen?')) {
        sysuser.deleteUser(this,this.user.id,function() {
          router.push({name: 'UserList',params: {}});
        })
      }
    },
    addRoles: function() {
      console.log(this.selectall);
      var self = this;
      this.selectall.forEach(item => {
        if (!self.userroles.includes(item.roleId)) self.userroles.push(item.roleId);
      });

    },
    remRoles: function() {
      console.log(this.selectactive);
      var self = this;
      this.userroles = this.userroles.filter(item => { return !self.selectactive.includes(item); });
    },
    fetchRoles: function() {
      var self = this;
      sysuser.getroles(this,this.user.id,function(data) {
        self.userroles = data;
      })
    }
  }
}
</script>
